export const TIPO_VEICULO = {
  MOTO: 1,
  CARRO: 2,
  CAMINHAO: 3,
};
